'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$22() {
  this.bfU = null;
  this.bfS = null;
  this.bfT = false;
  this.bfQ = null;
  this.bfR = false;
  this.bfV = false;
  this.bfW = false;
  this.bfU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$22 as $c_Lpresto_PrestoRouter$$anon$22 };
$p = $c_Lpresto_PrestoRouter$$anon$22.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$22;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$22() {
}
export { $h_Lpresto_PrestoRouter$$anon$22 as $h_Lpresto_PrestoRouter$$anon$22 };
$h_Lpresto_PrestoRouter$$anon$22.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bfU;
});
$p.t = (function() {
  if ((!this.bfT)) {
    this.bfS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfT = true;
  }
  return this.bfS;
});
$p.ae = (function() {
  if ((!this.bfR)) {
    this.bfQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfR = true;
  }
  return this.bfQ;
});
$p.w = (function() {
  if ((!this.bfW)) {
    this.bfV = false;
    this.bfW = true;
  }
  return this.bfV;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$22 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$22, "presto.PrestoRouter$$anon$22", ({
  NN: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$22 as $d_Lpresto_PrestoRouter$$anon$22 };
//# sourceMappingURL=presto.-Presto-Router$$anon$22.js.map
